import Vue from 'vue'
import axios from 'axios'
import jwtDecode from 'jwt-decode'

const TOKEN_NAME = 'token'

export default new Vue({
    data () {
        return {
            user: {},
            token: null
        }
    },
    created () {
        const token = localStorage.getItem(TOKEN_NAME)
        this.setToken(token)
    },
    methods: {
        storeUser (user) {
            this.user = user
            this.$emit('user-update', user)
        },
        login (email, password) {
            return axios.post('/auth/login', {
                email,
                password
            })
                .then(res => {
                    const { token } = res.data
                    this.setToken(token)
                    return res
                })
        },
        logout () {
            localStorage.removeItem(TOKEN_NAME)
            this.token = null
            this.storeUser({})
        },
        setToken (value) {
            const decodedToken = this.decodeToken(value)

            if (decodedToken && decodedToken.user) {
                localStorage.setItem(TOKEN_NAME, value)
                this.token = value
                this.storeUser(decodedToken.user)
            } else {
                this.token = null
            }
        },
        decodeToken (token) {
            try {
                const decoded = jwtDecode(token)
                return decoded
            } catch (e) {
                return null
            }
        },
        refreshToken () {
            if (!this.token) {
                return Promise.resolve()
            }

            return axios.get('/auth/refresh-token')
                .then(res => {
                    const { token } = res.data

                    this.setToken(token)
                })
                .catch(err => {
                    console.error('Error refreshing token', err)
                })
        },
        tokenHasExpired () {
            try {
                const decoded = jwtDecode(this.token)

                const expire = decoded.exp
                const now = (new Date().getTime() / 1000)

                if (now > expire) {
                    this.logout()
                    return true
                } else {
                    return false
                }
            } catch (err) {
                // assume invalid token
                this.logout()
                return true
            }
        }
    }
})
